import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"max-width":"500px"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(VCard,[_c(VCardTitle,[_vm._v(" Atualizar conjunto ")]),_c(VCardText,{staticClass:"py-5"},[_c('engine-selector',{attrs:{"engines":_vm.engines,"onChange":_vm.handleEngineChange,"allow-creation":false,"initial-value":_vm.currentEngineName,"label":"Selecione o motor"}}),_c(VCardActions,[_c(VBtn,{attrs:{"color":"primary","disabled":!Boolean(_vm.engineName)},on:{"click":_vm.handleConfirm}},[_vm._v(" Salvar ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }